const base64 = require('base-64');
const { fetchAuthorizedJsonApi, fetchJsonApi } = require('./abstract');

const versionPrefix = 'v2';
const passwordResetVersionPrefix = 'v3';

function googleLogin(apiUrl, loginData) {
  const query = {
    code: loginData.serverAuthCode,
  };

  return fetchJsonApi({
    apiUrl,
    method: 'GET',
    endpoint: `${versionPrefix}/auth/googleLogin`,
    query,
    expectedStatus: 200,
    description: 'Login via Google',
  });
}

function googleLoginApp(apiUrl, loginData) {
  return fetchJsonApi({
    apiUrl,
    method: 'POST',
    endpoint: `${versionPrefix}/auth/googleLogin`,
    body: {
      access_token: loginData.accessToken,
      refresh_token: null,
    },
    expectedStatus: 200,
    description: 'Login via Google',
  });
}

function facebookLogin(apiUrl, loginData) {
  const query = {
    code: loginData.code,
  };

  return fetchJsonApi({
    apiUrl,
    method: 'GET',
    endpoint: `${versionPrefix}/auth/facebookLogin`,
    query,
    expectedStatus: 200,
    description: 'Login via Facebook',
  });
}

function facebookLoginApp(apiUrl, loginData) {
  return fetchJsonApi({
    apiUrl,
    method: 'POST',
    endpoint: `${versionPrefix}/auth/facebookLogin`,
    body: {
      access_token: loginData.accessToken,
      refresh_token: null,
    },
    expectedStatus: 200,
    description: 'Login via Facebook',
  });
}

function twitterLoginApp(apiUrl, loginData) {
  return fetchJsonApi({
    apiUrl,
    method: 'POST',
    endpoint: `${versionPrefix}/auth/twitterLogin`,
    body: loginData,
    expectedStatus: 200,
    description: 'Login via Twitter',
  });
}

function passwordLogin(apiUrl, loginData, query = {}) {
  const credentials = base64.encode(
    `${encodeURIComponent(loginData.username)}:${encodeURIComponent(
      loginData.password,
    )}`,
  );

  return fetchJsonApi({
    apiUrl,
    method: 'POST',
    endpoint: `${versionPrefix}/auth/passwordLogin`,
    query,
    headers: {
      Authorization: `Basic ${credentials}`,
    },
    expectedStatus: 200,
    description: 'Password login',
  });
}

function register(apiUrl, email, password, query = {}) {
  return fetchJsonApi({
    apiUrl,
    method: 'POST',
    endpoint: `${versionPrefix}/auth/register`,
    query,
    body: {
      email,
      password,
    },
    expectedStatus: 200,
    description: 'Registration',
  });
}

function requestPasswordReset(apiUrl, user, query = {}) {
  return fetchJsonApi({
    apiUrl,
    method: 'POST',
    endpoint: `${passwordResetVersionPrefix}/auth/requestPasswordReset`,
    query,
    body: {
      user,
    },
    expectedStatus: 204,
    description: 'Password reset request',
  });
}

function requestPasswordResetToken(apiUrl, email, code) {
  return fetchJsonApi({
    apiUrl,
    method: 'POST',
    endpoint: `${passwordResetVersionPrefix}/auth/resetPasswordToken`,
    body: { email, code },
    expectedStatus: 200,
    description: 'Request password reset token',
  });
}

function resetPassword(apiUrl, token, newPassword) {
  return fetchJsonApi({
    apiUrl,
    method: 'POST',
    endpoint: `${passwordResetVersionPrefix}/auth/resetPassword`,
    body: {
      token,
      newPassword,
    },
    expectedStatus: 200,
    description: 'Reset password',
  });
}

function getDiscordAuthCodeUrl(apiUrl) {
  return fetchJsonApi({
    apiUrl,
    method: 'GET',
    endpoint: `${versionPrefix}/auth/connect-discord`,
    expectedStatus: 200,
    description: 'Connect with Discord',
  });
}

function connectWithDiscord(apiUrl, token, code) {
  return fetchAuthorizedJsonApi({
    apiUrl,
    token,
    method: 'PUT',
    endpoint: `${versionPrefix}/auth/connect-discord`,
    body: { code },
    expectedStatus: 200,
    description: 'Connect with Discord',
  });
}

function getAppleAuthUrl(apiUrl, platform = 'web') {
  return fetchJsonApi({
    apiUrl,
    method: 'GET',
    endpoint: 'v1/auth/apple-login',
    query: { platform },
    expectedStatus: 200,
    description: 'Getting Apple auth url',
  });
}

function appleLogin(apiUrl, { code }) {
  return fetchJsonApi({
    apiUrl,
    method: 'POST',
    endpoint: 'v1/auth/apple-login',
    body: { code },
    expectedStatus: 200,
    description: 'Login with Apple',
  });
}

function getAccountTransferAuthUrl(apiUrl, token, platform = 'web') {
  return fetchAuthorizedJsonApi({
    apiUrl,
    token,
    method: 'GET',
    endpoint: 'v1/auth/instagram/data-transfer',
    query: { platform },
    expectedStatus: 200,
    description: 'Getting account transfer auth url',
  });
}

function getHuaweiAuthCodeUrl(apiUrl, query = {}) {
  return fetchJsonApi({
    apiUrl,
    method: 'GET',
    endpoint: `${versionPrefix}/auth/huawei`,
    query,
    expectedStatus: 200,
    description: 'Login with Huawei',
  });
}

function huaweiLogin(apiUrl, { code } = {}) {
  return fetchJsonApi({
    apiUrl,
    method: 'PUT',
    endpoint: `${versionPrefix}/auth/huawei`,
    body: { code },
    expectedStatus: 200,
    description: 'Login with Huawei',
  });
}

function verifyCaptcha(apiUrl, captchaResponse) {
  return fetchJsonApi({
    apiUrl,
    method: 'GET',
    endpoint: 'v1/auth/captcha',
    query: { 'g-recaptcha-response': captchaResponse },
    expectedStatus: 200,
    description: 'Captcha verification',
  });
}

module.exports = {
  googleLogin,
  googleLoginApp,
  facebookLogin,
  facebookLoginApp,
  // twitterLogin,
  twitterLoginApp,
  passwordLogin,
  register,
  requestPasswordReset,
  requestPasswordResetToken,
  resetPassword,
  getDiscordAuthCodeUrl,
  getHuaweiAuthCodeUrl,
  huaweiLogin,
  getAppleAuthUrl,
  getAccountTransferAuthUrl,
  connectWithDiscord,
  verifyCaptcha,
  appleLogin,
};
